import { CartBuyerUi } from '@/components/Cart/modal/CartUiModel';
import FormItem from '@/components/Common/FormItem/FormItem';
import useSearchBuyers from '@/hooks/product/catalog/useSearchBuyers';
import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React from 'react';
import { buyerResponseToCartBuyerui } from '../../mapper';

export default function BuyerSearch({
  buyerSelected,
  onBuyerSelected,
  disabled,
  errorMessage,
}: {
  buyerSelected?: CartBuyerUi;
  onBuyerSelected: (buyer?: CartBuyerUi) => void;
  disabled?: boolean;
  errorMessage?: string;
}) {
  const searchBuyersHook = useSearchBuyers();
  const buyerOptions = (): CartBuyerUi[] => {
    return searchBuyersHook.data?.data?.map(buyerResponseToCartBuyerui) ?? [];
  };

  return (
    <FormItem helperText={errorMessage}>
      <Autocomplete
        disabled={disabled}
        options={buyerOptions()}
        freeSolo={false}
        popupIcon={<></>}
        noOptionsText={''}
        getOptionLabel={(option) => option.name}
        getOptionKey={(option) => option.id}
        renderInput={(params) => (
          <TextField
            {...params}
            error={!!errorMessage}
            placeholder="Nombre del comprador"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <SearchIcon />
                </>
              ),
              endAdornment: (
                <React.Fragment>
                  {searchBuyersHook.isFetching ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={buyerSelected ?? null}
        onChange={(_, buyer) => {
          onBuyerSelected(buyer ?? undefined);
        }}
        onInputChange={(_e, newInputValue) => {
          searchBuyersHook.setQuery(newInputValue);
        }}
      />
    </FormItem>
  );
}
